module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workOrder"
  }, [_c('div', {
    staticClass: "workOrder-wrap"
  }, [_c('h1', {
    staticClass: "personal-center-form__title"
  }, [_vm._v("工单咨询")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工单Id"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formSearch.userRepairOrderId),
      callback: function($$v) {
        _vm.$set(_vm.formSearch, "userRepairOrderId", $$v)
      },
      expression: "formSearch.userRepairOrderId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单标题"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formSearch.orderTitle),
      callback: function($$v) {
        _vm.$set(_vm.formSearch, "orderTitle", $$v)
      },
      expression: "formSearch.orderTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.formSearch.orderState),
      callback: function($$v) {
        _vm.$set(_vm.formSearch, "orderState", $$v)
      },
      expression: "formSearch.orderState"
    }
  }, _vm._l((_vm.stateMap), function(value, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": value,
        "value": key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisibleOrder = true
      }
    }
  }, [_vm._v("新建工单")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.workIfoList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "userRepairOrderId",
      "label": "工单id",
      "align": "center",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderTitle",
      "label": "工单标题",
      "align": "center",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createtime",
      "label": "工单创建时间",
      "align": "center",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工单更新时间",
      "align": "center",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.updatetime || '暂无') + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "工单状态",
      "align": "center",
      "min-width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm.stateMap[scope.row.orderState]) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "min-width": "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleClick(scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.deleteClick(scope.row)
            }
          }
        }, [_vm._v("关闭")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [(_vm.workIfoList.length > 0) ? _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 10,
      "layout": "total, prev, pager, next",
      "total": _vm.totalCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('confirm-modal', {
    attrs: {
      "show": _vm.isDeleteWorkOrder,
      "content": "是否确定关闭该条工单？"
    },
    on: {
      "cancel-click": function($event) {
        _vm.isDeleteWorkOrder = false
      },
      "confirm-click": _vm.deleteWorkOrder
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建工单",
      "visible": _vm.dialogFormVisibleOrder
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisibleOrder = $event
      }
    }
  }, [_c('el-form', {
    ref: "addOrderForm",
    staticClass: "work_order_add",
    attrs: {
      "model": _vm.addOrderForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工单标题：",
      "label-width": _vm.formLabelWidth,
      "prop": "orderTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "width": "100px"
    },
    model: {
      value: (_vm.addOrderForm.orderTitle),
      callback: function($$v) {
        _vm.$set(_vm.addOrderForm, "orderTitle", $$v)
      },
      expression: "addOrderForm.orderTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "el-order-height",
    attrs: {
      "label": "工单内容：",
      "label-width": _vm.formLabelWidth,
      "prop": "orderContent"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addOrderForm.orderContent),
      callback: function($$v) {
        _vm.$set(_vm.addOrderForm, "orderContent", $$v)
      },
      expression: "addOrderForm.orderContent"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisibleOrder = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('addOrderForm')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c179214"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/workOrder.vue
// module id = 1088
// module chunks = 1